
import React from 'react';
import { Clock, LogOut } from 'lucide-react';
import LegalFooter from '@/components/LegalFooter';

const PendingApproval = ({ user, onLogout }) => {
  return (
    <div className="relative min-h-screen flex items-center justify-center p-4 bg-gradient-to-br from-[#0a1628] via-[#1a365d] to-[#2563eb]">
      <div
        className="w-full max-w-[440px] bg-white dark:bg-slate-800 rounded-2xl overflow-hidden text-center p-8"
        style={{
          boxShadow: '0 25px 60px -15px rgba(0, 0, 0, 0.35), 0 10px 30px -10px rgba(0, 0, 0, 0.2), 0 0 40px -5px rgba(59, 130, 246, 0.15)'
        }}
      >
        <div className="mx-auto mb-5 w-16 h-16 rounded-full bg-amber-100 flex items-center justify-center">
          <Clock className="h-8 w-8 text-amber-600" />
        </div>

        <h1 className="text-[#0f172a] text-xl font-semibold tracking-tight mb-2">
          Compte en attente d'approbation
        </h1>

        <p className="text-[#475569] text-sm mb-1">
          Bonjour {user?.name || ''},
        </p>
        <p className="text-[#64748b] text-sm mb-6">
          Votre compte est en attente d'approbation d'un administrateur.
          Un email a été envoyé pour l'en informer. Vous recevrez l'accès dès
          que votre compte aura été validé.
        </p>

        <button
          onClick={onLogout}
          className="inline-flex items-center gap-2 text-sm text-[#2563eb] hover:text-[#1d4ed8] font-medium"
        >
          <LogOut className="h-4 w-4" />
          Se déconnecter
        </button>
      </div>
      <LegalFooter className="absolute bottom-3 inset-x-0 !mt-0 text-blue-200/70" />
    </div>
  );
};

export default PendingApproval;
